export enum EMenuTypes {
  PARENT = "parent",
  URL = "url",
  CONTENT = "content",
  CATEGORY = "contentCategory",
}
